import { http, HttpResponse } from 'msw'

import type { CreateChainAgencyResponsibleDataParams } from '../../agency/craate-chain-agency-responsible-data'

interface CreateChainAgencyResponsibleDataPathParams {
  alphaId: string
}

export const mockCreateChainAgencyResponsibleData = http.post<
  CreateChainAgencyResponsibleDataPathParams,
  CreateChainAgencyResponsibleDataParams
>(
  '/my-business/api/agency/v1/agency-chains/:alphaId/responsible-data',
  async ({ request }) => {
    const requestBody = await request.json()

    if (requestBody.responsibleTaxpayerId === '00000000000000') {
      const error = {
        message: 'E001',
        detail: 'CPF Inválido',
      }

      return HttpResponse.json({ error }, { status: 400 })
    }

    return HttpResponse.json(
      { preSignedUrl: '/api/agency/v1/agency-chains/upload-contract' },
      { status: 200 },
    )
  },
)
